import { render, staticRenderFns } from "./CreateNewOrder.vue?vue&type=template&id=7c8dfaee&scoped=true&"
import script from "./CreateNewOrder.vue?vue&type=script&lang=js&"
export * from "./CreateNewOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewOrder.vue?vue&type=style&index=0&id=7c8dfaee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8dfaee",
  null
  
)

export default component.exports